var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.order.transaction.method.type == 'CARD')?_c('CheckCardStatus',_vm._g({attrs:{"order":_vm.order}},_vm.$listeners)):_vm._e(),_vm._v(" "),(_vm.order.transaction.method.type == 'TRANSFER')?_c('ConfirmTransfer',_vm._g({attrs:{"order":_vm.order}},_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }